import { useContext, useCallback, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'
import { flattenDeep, debounce } from 'lodash'
import styled from 'styled-components'
import { Provider } from 'react-redux'

import * as cartRepository from 'scripts/api/cart'

import { Drawer } from 'reactShared/components/Drawer'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

import { configureStore } from 'checkout/redux/store'
import { getServiceListMiniCart } from 'checkout/services/api/cart'

import { Contents } from './components/Contents'

const store = configureStore()

const Container = styled.div(
  ({ theme }) => `
    width: 100%;

    @media (min-width: ${theme.media.tablet}) {
      width: 480px;
    }
  `
)

const haveItens = shippings => {
  return !!(shippings.length && shippings[0].items.length)
}

const CartDrawer = ({ cart }) => {
  const headerContext = useContext(HeaderContext)
  const { isCartDrawerOpen, toggleCartDrawer, userResources: { region } } = headerContext
  const [currentCart, setCart] = useState(cart)
  const [availableServices, setAvailableServices] = useState([])

  const serviceRequest = useCallback(debounce(async (params) => {
    const { data } = await getServiceListMiniCart(params)

    setAvailableServices(data.data)
  }, 600), [setAvailableServices])

  useEffect(() => {
    const ids = flattenDeep(
      cart.shippings
        .map(shipping =>
          shipping.items
            .map(item => ({
              id: item.productId,
              skuId: item.skuId
            })))
    )

    const params = qs.stringify(
      {
        regionId: region,
        products: ids
      },
      {
        addQueryPrefix: true,
        arrayFormat: 'indices',
        encode: false,
        skipNulls: true
      }
    )

    if (ids.length > 0) {
      serviceRequest(params)
    }
  }, [cart, region, serviceRequest])

  const resetCart = async () => {
    try {
      const response = await cartRepository.getCart()
      const {
        uniqueProductsCount,
        total,
        subTotal,
        discountTotal,
        shippings,
        services
      } = response.data

      setCart({
        uniqueProductsCount,
        total,
        subTotal,
        discountTotal,
        shippings,
        services
      })
    } catch (err) {
      return err
    }
  }

  return (
    <Drawer
      isOpen={isCartDrawerOpen}
      overlayClick={toggleCartDrawer}
      className="stock-info-drawer"
    >

      <Provider store={store}>
        <Container>
          {
            (haveItens(cart.shippings) || isCartDrawerOpen) &&
              <Contents
                {...cart}
                resetCart={resetCart}
                regionId={region}
                isCartDrawerOpen={isCartDrawerOpen}
                availableServices={availableServices}
              />
          }
        </Container>
      </Provider>
    </Drawer>
  )
}

CartDrawer.propTypes = {
  cart: PropTypes.shape({
    shippings: PropTypes.array,
    subTotal: PropTypes.number,
    discountTotal: PropTypes.number,
    total: PropTypes.number
  })
}

export default CartDrawer
